import { createSlice } from "@reduxjs/toolkit";
import { setInitialState } from "../../../store/InitialState";

const INITIAL_STATE = setInitialState({
	data: null,
	isFetching: false,
	isSuccess: false,
	isError: false,
	error: null,
});

const fetchAllPickerListAllslice = createSlice({
	name: "fetchAllPickerListAllslice",
	initialState: INITIAL_STATE,
	reducers: {
		fetchAllPickerListRequest: (state) => {
			state.isFetching = true;
		},
		fetchAllPickerListSuccess: (state, action) => {
			state.isFetching = false;
			state.isSuccess = true;
			state.data = action.payload;
		},
		fetchAllPickerListFailuer: (state, action) => {
			state.isFetching = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.payload;
		},
		resetFetchAllPickerList: (state) => {
			state.data = null;
			state.error = null;
			state.isError = false;
			state.isFetching = false;
			state.isSuccess = false;
		},
	},
});

// Exporting actions for saga and views
export const {
	fetchAllPickerListRequest,
	fetchAllPickerListSuccess,
	fetchAllPickerListFailuer,
	resetFetchAllPickerList,
} = fetchAllPickerListAllslice.actions;

// const selectLogin = (state: any) => state.fetchAllPickerListAllslice;

// export const selectLoginData = createSelector(selectLogin, (login) => {
//     return login.data;
// });

// Exporting fetchAllPickerListAllslice reducer for combine reducer
export default fetchAllPickerListAllslice.reducer;
